import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../../../core/services/currency.service';

@Pipe({
  name: 'appendCurrency',
  standalone: false,
  pure: false, // Ensures immediate re-rendering across all products when currency changes
})
export class AppendCurrencyPipe implements PipeTransform {
  constructor(private readonly currencyService: CurrencyService) {}

  transform(value: number | string | undefined, currencyCode?: string): string {
    const targetCurrency = (currencyCode || this.currencyService.currentCurrency || 'EUR').toUpperCase();
    const symbol = targetCurrency === 'PLN' ? 'zł' : '€';

    if (value === undefined || value === null) return `0,00 ${symbol}`;
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numericValue)) {
      return `0,00 ${symbol}`;
    }

    // Convert from base EUR price to PLN when PLN is active
    const displayValue = targetCurrency === 'PLN'
      ? this.currencyService.convertFromEur(numericValue)
      : numericValue;
    if (!Number.isFinite(displayValue)) {
      return 'Conversion unavailable - try again later';
    }

    // Format with space as thousands separator and comma as decimal separator
    const formatted = displayValue.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    // Replace single space with double space for thousands separator
    const formattedWithMoreSpace = formatted.replace(/(\d)\s(\d)/g, '$1  $2');
    
    return `${formattedWithMoreSpace} ${symbol}`;
  }
}
